export default function (url) {
  // console.log('Trimming', url);
  while (url?.endsWith('/')) {
    // eslint-disable-next-line no-param-reassign
    url = url.slice(0, -1);
  }
  return url;
}
